import {useEffect, useState} from "react";
import ApiService from "../../core/service/api-service";
import useRequest from "../../core/utils/useRequest";
import {Button, Table, Typography} from "antd";
import {t} from "i18next";
import {ReloadOutlined} from "@ant-design/icons";

export default function SeriesMetadataTable({studyId, studyInstanceUid}) {
    const [data, setData] = useState([])

    // silent: küresel gösterge susar; geri bildirim tablonun kendi loading'inde.
    const getMetadata = async () => {
        const res = await ApiService.Dicom.GetSeriesMetadata(studyId, {silent: true})
        if(res.success) {
            setData(res.data)
        }
    }

    const {run: loadMetadata, loading} = useRequest(getMetadata)

    useEffect(() => {
        loadMetadata()
    }, []);

    return (
        <>
            {studyInstanceUid && (
                <div style={{ marginBottom: 8 }}>
                    <Typography.Text strong>{t('Study Instance UID')}: </Typography.Text>
                    <Typography.Text copyable style={{ fontSize: 12 }}>{studyInstanceUid}</Typography.Text>
                </div>
            )}
            <Table
                title={() => {
                    return (
                        <div style={{display: 'flex', alignItems: 'center', gap: 16, justifyContent: 'space-between'}}>
                            <Button
                                size={'small'}
                                loading={loading}
                                onClick={() => loadMetadata()}
                                icon={<ReloadOutlined />}
                            />
                            <Typography.Text>
                                <b>{t('Total Instance Count')}: </b> {data.length > 0 && data?.map(x => parseInt(x.instanceCount))?.reduce((a,b) => a + b)}
                            </Typography.Text>
                        </div>
                    )
                }}
                size={'small'}
                loading={loading}
                dataSource={data}
                pagination={false}
                style={{width: 800}}
                id={'seriesNumber'}
                columns={[
                    {
                        dataIndex: 'seriesNumber',
                        key: 'seriesNumber',
                        title: t('Series Number'),
                        width: 125
                    },
                    {
                        dataIndex: 'desc',
                        key: 'desc',
                        title: t('Series Description')
                    },
                    {
                        dataIndex: 'modality',
                        key: 'modality',
                        title: t('Modality'),
                        width: 125
                    },
                    {
                        dataIndex: 'instanceCount',
                        key: 'instanceCount',
                        title: t('Instance'),
                        width: 125
                    }
                ]}
            />
        </>
    )
}